
var treeSelectLess = {};
import genaration from '../../utils/classname';
export var treeSelectClass = genaration(treeSelectLess, 'treeSelect');